import React from 'react';
import { Link } from 'react-router-dom';

const PopularSearches = () => {
  const popularSearches = [
    { name: 'Ceremony Photographers', slug: 'photographers-content-creators', icon: '📸' },
    { name: 'Catering Services', slug: 'catering-services', icon: '🍽️' },
    { name: 'Ceremony Venues', slug: 'venues', icon: '🏛️' },
    { name: 'Makeup Artists', slug: 'makeup-artists', icon: '💄' },
    { name: 'Ceremony Decorators', slug: 'decorators', icon: '🎨' },
    { name: 'DJ & Music', slug: 'dj-music', icon: '🎵' },
    { name: 'Ceremony Cakes', slug: 'cakes-gift-shops', icon: '🎂' },
    { name: 'Bridal Wear', slug: 'function-wear', icon: '👗' }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Popular Searches
          </h2>
          <p className="text-lg text-gray-600">
            Quick access to the most searched ceremony services
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6">
          {popularSearches.map((search, index) => (
            <Link
              key={index}
              to={`/category/${search.slug}`}
              className="flex flex-col items-center p-6 rounded-lg hover:bg-gray-50 transition-colors duration-200 group"
            >
              <div className="text-4xl mb-3 group-hover:scale-110 transition-transform duration-200">
                {search.icon}
              </div>
              <span className="text-base text-center text-gray-700 group-hover:text-blue-600 transition-colors duration-200">
                {search.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularSearches;